import { TableHeadCell } from "@shared/primitive-components"

export const distanceDrivenHeaderProps = {
  header: `Miles driven`,
  tooltipContent: `Total mileage completed by this vehicle over the past 30 days.`,
}

export const DistanceDrivenHeader = () => <TableHeadCell {...distanceDrivenHeaderProps} />
